import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import Contact from './components/Contact';
import Breadcrumb from '@/components/base/Breadcrumb';
import PageSEO from '@/components/base/PageSEO';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于17c',
  description: '17c成立于2020年，通过技术创新，为每一位用户提供高效、便捷、可靠的数字化服务体验。',
  url: 'https://17cinfo.github.io/about',
};

export default function About() {
  return (
    <PageSEO
      title="关于我们 - 17c品牌介绍与联系方式 | 17c官网"
      description="了解17c的品牌故事、发展历程、核心价值观、行业荣誉和合作伙伴信息，获取17c的联系方式和客服支持。"
      keywords="17c品牌,17c联系方式,17c关于我们,17c客服"
      canonicalPath="/about"
      schema={aboutSchema}
    >
      <div className="pt-24 md:pt-28 px-4 md:px-6 bg-background-50">
        <div className="max-w-5xl mx-auto fade-in-up">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />
          <div className="text-center mb-10">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950">
              关于我们
            </h1>
          </div>
        </div>
      </div>

      <div className="fade-in-up fade-in-up-delay-1">
        <BrandIntro />
      </div>
      <div className="fade-in-up fade-in-up-delay-2">
        <Reputation />
      </div>
      <div className="fade-in-up fade-in-up-delay-3">
        <Contact />
      </div>
    </PageSEO>
  );
}